import { cn } from '@/lib/utils';

const levelClass: Record<string, string> = {
  debug: 'bg-status-neutral-soft text-status-neutral',
  info: 'bg-status-info-soft text-status-info',
  warn: 'bg-status-warning-soft text-status-warning',
  error: 'bg-status-danger-soft text-status-danger',
};

/** Token-based log level pill. Unknown levels fall back to the neutral style. */
export function LevelPill({ level }: { level: string }) {
  return (
    <span
      className={cn(
        'inline-flex h-5 items-center rounded-full px-2 text-xs font-medium uppercase whitespace-nowrap',
        Object.hasOwn(levelClass, level) ? levelClass[level] : levelClass.debug,
      )}
    >
      {level}
    </span>
  );
}
